import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const ProjectHistoryCard: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const {
    inc_projects,
    inc_keyprojects,
    inc_netumonly,
    inc_bundlesubprojects,
    inc_employer,
    inc_projectemployer,
    inc_projectclientname,
    inc_projectclientcontact,
    inc_projectduration,
    inc_projecttimeframe,
    inc_projectindustry,
    inc_projectdescription,
    inc_persondescription,
    inc_personskills,
    inc_bundleskills,
    inc_personroles,
    inc_skillsexperience,
    inc_rolesexperience,
    inc_skillsandroles,
  } = state

  return (
    <CVCard
      title={t('CVTemplates.ProjectHistory')}
      description={t('CVTemplates.ProjectExperienceAndClientWork')}
      isEnabled={inc_projects}
      toggleName='inc_projects'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <OPCheckBox
          name='inc_keyprojects'
          label={t('CVTemplates.KeyProjectsOnly')}
          value={inc_keyprojects}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_netumonly'
          label={t('CVTemplates.NetumProjectsOnly')}
          value={inc_netumonly}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_bundlesubprojects'
          label={t('CVTemplates.BundleSubprojects')}
          value={inc_bundlesubprojects}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox name='inc_employer' label={t('CVTemplates.ShowEmployer')} value={inc_employer} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_projectemployer'
          label={t('CVTemplates.ShowAssigner')}
          value={inc_projectemployer}
          disabled
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_projectclientname'
          label={t('CVTemplates.ShowClientName')}
          value={inc_projectclientname}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_projectclientcontact'
          label={t('CVTemplates.ShowClientContact')}
          value={inc_projectclientcontact}
          disabled
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_projectduration'
          label={t('CVTemplates.ShowDuration')}
          value={inc_projectduration}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_projecttimeframe'
          label={t('CVTemplates.ShowProjectTimeframe')}
          value={inc_projecttimeframe}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_projectindustry'
          label={t('CVTemplates.ShowIndustry')}
          value={inc_projectindustry}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_projectdescription'
          label={t('CVTemplates.ShowProjectDescription')}
          value={inc_projectdescription}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_persondescription'
          label={t('CVTemplates.ShowPersonDescription')}
          value={inc_persondescription}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_personskills'
          label={t('CVTemplates.ShowSkills')}
          value={inc_personskills}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_bundleskills'
          label={t('CVTemplates.BundleSkills')}
          value={inc_bundleskills}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox name='inc_personroles' label={t('CVTemplates.ShowRoles')} value={inc_personroles} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_skillsexperience'
          label={t('CVTemplates.ShowSkillsExperience')}
          value={inc_skillsexperience}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_rolesexperience'
          label={t('CVTemplates.ShowRolesExperience')}
          value={inc_rolesexperience}
          disabled
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_skillsandroles'
          label={t('CVTemplates.ShowKeySkillsAndRoles')}
          value={inc_skillsandroles}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
